import { gql } from 'apollo-angular';

const REMOVE_CATEGORY = gql`
  mutation RemoveCategory($id: Long!, $categoryId: Long!) {
    removeCategory(
      removeCategoryRequest: { id: $id, categoryId: $categoryId }
    ) {
      id
    }
  }
`;

export default REMOVE_CATEGORY;
